import { useI18n } from 'vue-i18n'

export const SUPPORTED_LOCALES = ['nl', 'en', 'id']

export function useLocale() {
    const { locale } = useI18n()

    function setLocale(lang) {
        // Persist selection so refresh/navigation keeps the same language context.
        locale.value = lang
        localStorage.setItem('locale', lang)
    }

    /**
     * Prepend the active locale to a path when the locale is not the default (nl).
     * e.g. localePath('/over') → '/over'        (when locale is 'nl')
     *      localePath('/over') → '/en/over'     (when locale is 'en')
     */
    function localePath(path) {
        if (locale.value === 'nl') return path
        return `/${locale.value}${path}`
    }

    return { locale, setLocale, localePath }
}
